export default function HomeDownload() {
  return (
    <section id="download" className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          立即下载 PG国际008
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-10 max-w-xl mx-auto">
          选择您的设备平台，一键下载PG国际008官方正版安装包，开启精彩游戏之旅
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <div className="w-full sm:w-72 p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer group">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-700 mx-auto mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
              <i className="ri-apple-fill text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">iOS 版本下载</h3>
            <p className="text-xs text-foreground-500 mb-5">支持 iOS 12.0 及以上</p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              iOS 下载
            </a>
          </div>
          <div className="w-full sm:w-72 p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-200/60 transition-all duration-300 cursor-pointer group">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-700 mx-auto mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
              <i className="ri-android-fill text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-foreground-950 mb-2">Android 版本下载</h3>
            <p className="text-xs text-foreground-500 mb-5">支持 Android 8.0 及以上</p>
            <a
              href="#"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              Android 下载
            </a>
          </div>
        </div>
        <p className="mt-8 text-xs text-foreground-400">
          * PG国际下载008安装包已通过安全检测，请放心下载。安装前请确保允许安装未知来源应用（Android）或信任企业证书（iOS）
        </p>
      </div>
    </section>
  );
}